import React from 'react';
import { ChevronDown } from 'lucide-react';

export function SectionSummary({
  icon,
  title,
  description,
  action,
  badge,
  badgeOn,
}: {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
  badge?: string;
  badgeOn?: boolean;
}) {
  return (
    <summary className="flex cursor-pointer list-none items-center gap-2 p-3 [&::-webkit-details-marker]:hidden">
      <ChevronDown className="h-3.5 w-3.5 shrink-0 -rotate-90 text-slate-400 transition-transform group-open:rotate-0" />
      {icon}
      <div className="min-w-0 flex-1">
        <h2 className="text-[13px] font-semibold text-slate-800">{title}</h2>
        {description && <p className="mt-0.5 text-[10px] leading-4 text-slate-500">{description}</p>}
      </div>
      {badge && (
        <span className={`rounded-full px-2 py-0.5 text-[9px] font-semibold uppercase tracking-wide ${badgeOn ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-100 text-slate-500'}`}>
          {badge}
        </span>
      )}
      {action}
    </summary>
  );
}

export function PanelHeading({
  icon,
  title,
  description,
}: {
  icon: React.ReactNode;
  title: string;
  description?: string;
}) {
  return (
    <div className="flex items-start gap-2">
      <div className="mt-0.5 text-slate-400">{icon}</div>
      <div>
        <h2 className="text-[13px] font-semibold text-slate-800">{title}</h2>
        {description && (
          <p className="mt-0.5 text-[10px] leading-4 text-slate-400">
            {description}
          </p>
        )}
      </div>
    </div>
  );
}
export function SmallField({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) {
  return (
    <label className="block">
      <span className="text-[11px] font-medium text-slate-600">{label}</span>
      {children}
    </label>
  );
}
export function inputSmall() {
  return 'mt-1.5 w-full rounded-lg border border-slate-200 bg-white px-2.5 py-2 text-[12px] text-slate-800 shadow-sm outline-none transition placeholder:text-slate-400 focus:border-primary-500 focus:ring-2 focus:ring-primary-100 disabled:bg-slate-50 disabled:text-slate-400';
}
